import { useTranslation } from "react-i18next";
import type { LocaleKey } from "../utils/svgPlaceholders";

interface ColumnLeftProps {
  locale: LocaleKey;
  showDescription?: boolean;
}

export const ColumnLeft = ({
  showDescription = false,
  locale: _locale,
}: ColumnLeftProps) => {
  const { t } = useTranslation();
  const descriptionParagraphs = t("layout.descriptionParagraphs", {
    returnObjects: true,
  }) as string[];

  return (
    <div className="column-left">
      <img
        src="/basiclaw2025-26/assets/logo.png"
        alt={t("layout.logoAlt")}
        className="column-left__logo"
      />
      {showDescription
        ? descriptionParagraphs.map((paragraph, index) => (
            <p
              key={paragraph}
              className={`column-left__description${
                index === 1 ? " column-left__description--inverse" : ""
              }`}
            >
              {paragraph}
            </p>
          ))
        : null}
    </div>
  );
};
